import React, { useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import COLORS from "../../../assets/Colors";
import { TabStyle, StyledText, UpdatesWrapper, Center } from "./styles";
import { makeStyles, Paper } from "@material-ui/core";
import styled from "styled-components";
import theme from "../../../assets/theme";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <TabStyle
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <StyledText style={{ height: "100%" }}>{children}</StyledText>
      )}
    </TabStyle>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    // flexGrow: 1,
    overflow: "hidden",
    width: "100%",
    height: "100%",
    marginTop: "50px",
    "& .MuiTabs-indicator": {
      height: "0px !important",
    },
    "& .MuiTab-root": {
      padding: "6px 12px 6px 0px",
    },
    [theme.breakpoints.up(640)]: {
      borderRadius: "11px",
      border: `solid 1px ${COLORS.HEADER_BORDER} `,
      "& .MuiTabs-indicator": {
        height: "4px !important",
      },
      //   "& .MuiTab-root": {
      //     padding: "6px 12px",
      //   },
    },
  },

  appBar: {
    color: COLORS.COLOR_DARK,
    backgroundColor: COLORS.INPUT_BACKGROUND,
    boxShadow: "none",
    [theme.breakpoints.up(640)]: {
      backgroundColor: COLORS.PRIMARY_WHITE,
      borderBottom: `solid 1px ${COLORS.HEADER_BORDER} `,
    },
  },

  label: {
    display: "flex",
    fontFamily: "openSans-SemiBold, sans-serif",
    color: COLORS.COLOR_DARK,
    justifyContent: "center",
    alignItems: "center",
    width: 80,
    fontSize: "14px",
    [theme.breakpoints.up(400)]: {
      width: "auto",
      maxWidth: 230,
    },
  },

  "& .MuiTab-root": {
    padding: 0,
  },
}));

export default function PollBarChart({ individualPollResponses }) {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  return (
    <Center className="mui-tabs">
      <UpdatesWrapper>
        <div className={classes.root}>
          <AppBar className={classes.appBar} position="static">
            <Tabs value={value} onChange={(_, newValue) => setValue(newValue)}>
              <Tab
                label={<div className={classes.label}>Polling</div>}
                {...a11yProps(0)}
              />
            </Tabs>
          </AppBar>

          <TabPanel value={value} index={0}>
            <GridContainer>
              <Paper
                style={{
                  padding: 16,
                  backgroundColor: "#E8F9FF",
                }}
              >
                {individualPollResponses?.length ? (
                  individualPollResponses.map((poll, index) => (
                    <div key={index} style={{ marginBottom: "30px" }}>
                      <Label>
                        {`Question ${index + 1}`} : {poll.question}
                      </Label>
                      {Object.entries(poll.optionCounts).map(
                        ([option, count], idx) => {
                          const percentage = poll.numberOfResponseForQuestion
                            ? (count / poll.numberOfResponseForQuestion) * 100
                            : 0;
                          return (
                            <div key={idx} style={{ marginBottom: "10px" }}>
                              <LableContainer>
                                <span>{option}</span>
                                <span>{count}</span>
                              </LableContainer>
                              <div
                                style={{
                                  background: "#ddd",
                                  borderRadius: "5px",
                                  overflow: "hidden",
                                }}
                              >
                                <Percentage
                                  style={{ textAlign: "right" }}
                                  percentage={percentage}
                                >
                                  {percentage.toFixed(1)}%
                                </Percentage>
                              </div>
                            </div>
                          );
                        },
                      )}
                    </div>
                  ))
                ) : (
                  <Paper
                    style={{
                      padding: 16,
                      backgroundColor: "#E8F9FF",
                    }}
                  >
                    No polling results found
                  </Paper>
                )}
              </Paper>
            </GridContainer>
          </TabPanel>
        </div>
      </UpdatesWrapper>
    </Center>
  );
}

const GridContainer = styled.div`
  margin: 15px;
  height: 530px;
  @media ${theme.breakpoints.sm_up} {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  }
`;

const Percentage = styled.div`
  height: 25px;
  width: ${({ percentage }) => `${percentage}%`};
  background-color: #3498db;
  border-radius: 5px;,
  text-align: right;
  color: #fff;
  padding-right: 5px;
  line-height: 25px;
  transition: width 0.5s ease-in-out;
`;

const LableContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
`;

const Label = styled.span`
  font-family: OpenSans-SemiBold, sans-serif;
  font-size: 14px;
  color: ${COLORS.INPUT_LABEL};
  text-transform: capitalize;
`;
